import { useAuthRoles } from '@/hooks'
import { jwtTokenAtom } from '@/store/root'

const Auth = () => {
  const { pathname } = useLocation()
  const roles = useAuthRoles()
  const jwtToken = useAtomValue(jwtTokenAtom)

  const authManage = useMemo(
    () => !!roles.type && pathname.startsWith('/manage') && ![2, 3].some(role => roles.type?.includes(role)),
    [roles.type, pathname]
  )

  if (!jwtToken || authManage) {
    return <Navigate replace to="/" />
  }

  return <Outlet />
}

export default Auth
